module.exports = __webpack_public_path__ + "img/tele2-emotions_5fb371e1f43d1abf01afd2ac17fb0793.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/tele2-emotions.jpg
// module id = 258
// module chunks = 0